import { setGlobalErrorStatus } from "Components/StatusHandling";
import { http } from "Utils";
import { config } from "Utils/config";
import { SPECIAL_CHARS_PATTERN } from "Utils/constants";
import { getRecaptchaToken } from "Components/ReCaptcha";
import parse from 'html-react-parser';

export const logS = {
    bold: "font-weight: 900;",
    none: "font-weight: reset;",
    colors: {
        red: 'color: red; font-weight: 900;',
        blue: 'color: blue; font-weight: 900;',
        purple: 'color: purple; font-weight: 900;',
        green: 'color: green; font-weight: 900;',
        brown: 'color: brown; font-weight: 900;',
        pink: 'color: #e91e63; font-weight: 900;',
        teal: 'color: MediumVioletRed; font-weight: 900;',
        orange: 'color: OrangeRed; font-weight: 900;',
        skyblye: 'color: SteelBlue; font-weight: 900;',
    }
}

export const containsOpenComment = (activeCommentKey, tempCommentList, event) => {
    var count = 0;
    for (const [key, value] of Object.entries(tempCommentList)) {
        var comment = value.item;
        var current = event;
        
        if((activeCommentKey==null || activeCommentKey!=event.id) && value.status != null && (value.status=="edit" || value.status=="add")){
            var currSplit = removeExtrasFromItemNum(current.itemNum);
            var commSplit = removeExtrasFromItemNum(comment.itemNum);

            var currLength = currSplit.length;
            var commLength = commSplit.length;

            if(currLength < commLength && compareJoinedElements(commSplit,currLength,currSplit,".")==true){
                count++;
            }
        }
    }
    
    config.isDebugEnabled && console.log("%cAccordion%c - %s - %c%s open comments", logS.colors.teal, logS.bold, event.itemNum, logS.none,count, tempCommentList);
    return count>0 ? true : false;
}

export const removeExtrasFromItemNum = (num) => {
    //console.log(num);
    if(num!=null){
        var split = num.split(".");
        if(split[split.length-1]=='0'){
            split.pop();
        }
        if(split[split.length-1]=='x'){
            if(split[split.length-2]=='0'){
                split.pop();
                split.pop();
                split.push('x');
            }
        }
        return split;
    }
    else{
        return [];
    }
    
}

export const getCFSplitName = (name) => {
    if(name!=null){
        const regex = /(?<name>[ A-Za-z]+) (?<version>V\d+\.\d+)/;     
        const result = name.match(regex);
        
        if(result!=null){
            return result.groups;
        }
    }
} 

export const getModuleDataByModuleId = (moduleId, moduleList) => {
    console.log(moduleId, moduleList);
    var found = null;
    for(var x = 0 ; x<moduleList.length ; x++){
        var m = moduleList[x];
        if(m!=null && m.hasOwnProperty('subs')){
            var arr = m.subs;
            for(var s = 0 ; s<arr.length ; s++){
                var i = arr[s];
                if(i.id==moduleId){
                    found = i;
                }
            }
        }
        else{
            if(m.id==moduleId){
                found = m;
            }
        }
    }
    return found;
}

export const getModuleDataByGroupId = (groupId, moduleList) => {
    console.log(groupId, moduleList);
    var found = null;
    for(var x = 0 ; x<moduleList.length ; x++){
        var m = moduleList[x];
        if(m!=null && m.hasOwnProperty('subs')){
            var arr = m.subs;
            for(var s = 0 ; s<arr.length ; s++){
                var i = arr[s];
                if(i.groupId==groupId){
                    found = i;
                }
            }
        }
        else{
            if(m.groupId==groupId){
                found = m;
            }
        }
    }
    return found;
}

export const getModuleDataByDocIdandCatId = (docId, categoryId, catResultsList) => {
    //console.log(docId, categoryId, catResultsList);
    var found = null;
    for(var x = 0 ; x<catResultsList.length ; x++){
        var m = catResultsList[x];
        if(m!=null && m.hasOwnProperty('moduleList')){
            var arr = m.moduleList;
            for(var s = 0 ; s<arr.length ; s++){
                var i = arr[s];
                if(i.docId==docId){
                    found = i;
                }
            }
        }
    }
    return found;
}

export const getModuleDataByModuleIdandCatId = (moduleId, categoryId, catResultsList) => {
    //console.log(moduleId, categoryId, catResultsList);
    var found = null;
    for(var x = 0 ; x<catResultsList.length ; x++){
        var m = catResultsList[x];
        if(m!=null && m.hasOwnProperty('moduleList')){
            var arr = m.moduleList;
            for(var s = 0 ; s<arr.length ; s++){
                var i = arr[s];
                if(i.moduleId==moduleId){
                    found = i;
                }
            }
        }
        
    }
    return found;
}

export const commentsMatch = (c1, c2) => {
    if(c1===c2){
        return true;
    }
    else{
        return false;
    }
}

export const getFormattedDate = (date) => {
    const dateOptions = {
        month: "short",
        day: "numeric",
    };
    const timeOptions = {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        //timeZoneName: "long"
    };
    var s = '';
    const dateString = new Intl.DateTimeFormat("en-US", dateOptions);
    const timeString = new Intl.DateTimeFormat("lookup", timeOptions);
    s = dateString.format(date) + ", " + timeString.format(date);
    return s;
}

export const validateCommentCall = async (text, categoryId, itemId, isGeneralComment,domId ) => {
    config.isDebugEnabled && console.log("%cAPI - %c%s", logS.bold, logS.colors.skyblye, "Validate comment");
    var url = "/api/ag/ct/comment/validateComment";
    var comment = {
        domId: domId,
        categoryId:categoryId,
        itemId:itemId,
        commentText: text,
        isGeneralComment: isGeneralComment
    }

    return http.post(url, comment);
}

export const validateCommentAPI = async (text, categoryId, itemId, isGeneralComment,domId ) => {
    config.isDebugEnabled && console.log("%cAPI - %c%s", logS.bold, logS.colors.skyblye, "Validate comment API");
    const result =  await validateCommentCall(text, categoryId, itemId, isGeneralComment,domId );
    return result;
}

export const getErrorList = (res) => {
    var errs = [];
    if(res?.data){
        var codes = res.data.errorCodeList;
        var messages = res.data.errorMessageList;

        for(var x = 0 ; x<codes.length ; x++){
            var c = codes[x];
            if(c!=null){
                var split = c.split("_");
                if(split.length > 1){
                    errs.push({code: split[1], msg: messages[x]});
                }
            }
        }  
    }
    return errs;
}

export const getCommentTempInputData = (obj, id, value) => {
    if(obj!=null && obj.hasOwnProperty(id)){
        var data = obj[id];
        if(value!=null){
            if(data!=null && data.hasOwnProperty(value)){
                return data[value];
            }
            else{
                return null;
            }
        }
        else{
            return data;
        }
    }
    else{
        return null;
    }
}

export const objContains = (obj, key) => {
    if(obj!=null && obj.hasOwnProperty(key)){
        return true;
    }
    else{
        return false;
    }
}

export const compareJoinedElements = (commSplit, currLength, currSplit, delimeter) => {
    var s = commSplit.slice(0,currLength);
    if(currSplit.join(delimeter)===s.join(delimeter)){
        return true;
    }
    else{
        return false;
    }
}



export const submitAllCall = async (data) => {
    config.isDebugEnabled && console.log("%cAPI - %c%s", logS.bold, logS.colors.skyblye, "Submit All");
    const captchaToken = await getRecaptchaToken('comment_save_all').catch(() => null);
    const payload = { ...data, captchaToken, captchaAction: 'comment_save_all' };
    var url = "/api/ag/ct/comment/saveAll";
    return http.post(url, payload);
}

export const submitAllAPI = async (data ) => {
    config.isDebugEnabled && console.log("%cAPI - %c%s", logS.bold, logS.colors.skyblye, "Submit All API");
    const result =  await submitAllCall(data);
    if (result.status === -1 && result.globalErrorMessageList?.length > 0) {
        const err = new Error(result.globalErrorMessageList[0]);
        err.globalErrorMessageList = result.globalErrorMessageList;
        throw err;
    }
    return result;
}

export const getHighlightHTML = (text, highlighted, id, focusKeyword, event, ref) => {
    var term = highlighted.term;
    const article = ref.current;
    const treeWalker = document.createTreeWalker(article, NodeFilter.SHOW_TEXT);
    const allTextNodes = [];
    let currentNode = treeWalker.nextNode();
    while (currentNode) {
        allTextNodes.push(currentNode);
        currentNode = treeWalker.nextNode();
    }
    //console.log(allTextNodes);
    // Listen to the input event to run the search.

  // If the CSS Custom Highlight API is not supported,
  // display a message and bail-out.
  if (!CSS.highlights) {
    article.textContent = "CSS Custom Highlight API not supported.";
    return;
  }

  // Clear the HighlightRegistry to remove the
  // previous search results.
  //CSS.highlights.clear();

  // Clean-up the search query and bail-out if
  // if it's empty.
  const str = term.trim().toLowerCase();
  if (!str) {
    return;
  }

  // Iterate over all text nodes and find matches.
  const ranges = allTextNodes
    .map((el) => ({ el, text: el.textContent.toLowerCase() }))
    .map(({ text, el }) => {
      const indices = [];
      let startPos = 0;
      while (startPos < text.length) {
        const index = text.indexOf(str, startPos);
        if (index === -1) break;
        indices.push(index);
        startPos = index + str.length;
      }

      // Create a range object for each instance of
      // str we found in the text node.
      return indices.map((index) => {
        const range = new Range();
        range.setStart(el, index);
        range.setEnd(el, index + str.length);
        return range;
      });
    });

    // Create a Highlight object for the ranges.
    const searchResultsHighlight = new window.Highlight(...ranges.flat());

    // Register the Highlight object in the registry.
    CSS.highlights.set("search-results", searchResultsHighlight);


    // const highlight = new window.Highlight(range1);
    // CSS.highlights.set("search-results", highlight);

    
    var escTerm = term.replace(/[`~!@#$%^*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "\\$&");
    var item = highlighted[id];
    var match = (focusKeyword!=null && id == focusKeyword.id);
    //console.log(event);
    return event.itemNameHtml;


}

export const getEventTypeName = (eventTypeList, activeKey) =>{
    if(eventTypeList!=null){
        //console.log(eventTypeList.find((m => m.id==activeKey)));
    
        for(var x = 0 ; x<eventTypeList.length ; x++){
            var module = eventTypeList[x];
            //console.log(module);

            if(module.hasOwnProperty('subs')){
                var subs = module.subs;
                for(var y = 0 ; y<subs.length ; y++){
                    var sub = subs[y];
                    if(sub.id==activeKey){
                        return sub.subModuleName;
                    }
                }
            }
            else{
                if(module.id==activeKey){
                    return module.moduleName;
                }
            }
        }
    } 
}

export const getCFNameByID = (id, cfList)=>{ 
    //console.log("getCFNameByID - id: " + id);

    if(id==0){
        return "General Comments";
    }
    else{
        if(cfList!=null){
            return cfList.find((a) => a.id==id).shortName;
        }
        else{
            return "";
        }
    }
}

export const getCFName = (key, cfList)=>{ 
    //console.log("getCFName - tabActiveKey: " + key);
    if(key==0){
        return "General Comments";
    }
    else{
        return cfList.find((a) => a.id==key).shortName;
    }
}

export const convertCTResp = (ctResp) => {
    var fieldErrors = {};
    if(ctResp.data?.errorCodeList && ctResp.data?.errorMessageList){
        var errorCodeList = ctResp.data.errorCodeList;
        var errorMessageList = ctResp.data.errorMessageList;

        for(var x = 0 ; x<errorCodeList.length ; x++){
            if(fieldErrors.hasOwnProperty([errorCodeList[x]])){
                ((fieldErrors[errorCodeList[x]]).errorMessages).push(errorMessageList[x]);
            }
            else {
                (fieldErrors[errorCodeList[x]]) = {
                    "fieldName": errorCodeList[x],
                    "hasError": true,
                    "errorMessages": [
                        errorMessageList[x]
                    ]
                }
            } 
        }
    }
    var data = {
        status: ctResp.data?.statusCode,
        data: ctResp.data?.data,
        fieldErrors: fieldErrors,
        globalErrorMessageList: [],
        message: ctResp.data?.statusDesc
    }
    return data;
}

export const highlightApi = (ref, searchTerm, highlightKey, occurence, excludeClasses, priority) => {
    try{
        // If the CSS Custom Highlight API is not supported
        if (!CSS.highlights) {
            //searchContainer.textContent = "CSS Custom Highlight API not supported.";
            return;
        }
        
        // Clear the HighlightRegistry to remove the previous search results.
        //CSS.highlights.clear();
        
        //Element to find and highlight the text in
        var searchContainer = ref.current;
        var searchContainerText = searchContainer.textContent.toLowerCase();
        
        var escapedSearchTerm = searchTerm.replace(SPECIAL_CHARS_PATTERN, "\\$&");
        var searchTermLength = searchTerm.length;

        const reg = new RegExp(`(${escapedSearchTerm})`,"gi");
        var matched = searchContainerText.matchAll(reg);
        var matches = [...matched];
        var matchesIndex = 0;

        var targetMatchData = matches[matchesIndex];
        var targetMatchStartIndex = targetMatchData.index;
        var targetMatchEndIndex = targetMatchStartIndex + searchTermLength;

        const treeWalker = document.createTreeWalker(searchContainer, NodeFilter.SHOW_TEXT);

        var tempIndex = 0;
        let currentNode = treeWalker.nextNode();
        
        var rangeStart = null;
        var rangeIndices = [];
    
        while (currentNode) {
            //"1.3.2 Leukopenia (<4000 WBC/mm3) or leukocytosis (>12,000 WBC/mm3)"
            var currentNodeMaxIndex = tempIndex + currentNode.length;

            //If current node includes start index of match and rangeStart is not yet set
            if(targetMatchStartIndex <= currentNodeMaxIndex && rangeStart==null) {
                //Start index of the match inside currentNode text
                var nodeMatchStartIndex = targetMatchStartIndex - tempIndex;
                rangeStart=[currentNode,nodeMatchStartIndex];
            }

            //If current node includes end index of match
            if(targetMatchEndIndex <= currentNodeMaxIndex){
                //End index of the match inside currentNode text
                var nodeMatchEndIndex = targetMatchEndIndex - tempIndex;

                //If visible and does not have parentElement with an excluded class
                if(!(excludeClasses!=null && excludeClasses.some(x => (currentNode.parentElement.className).includes(x))) && currentNode.parentElement.checkVisibility()==true){
                    rangeIndices.push({
                        start: rangeStart,
                        end: [currentNode,nodeMatchEndIndex]
                    })
                }
                rangeStart=null;

                //If there are remaining matches
                if(matches.length > matchesIndex + 1){ 
                    //Update variables with next match info
                    matchesIndex = matchesIndex + 1;
                    targetMatchData = matches[matchesIndex];
                    targetMatchStartIndex = targetMatchData.index;
                    targetMatchEndIndex = targetMatchStartIndex + searchTermLength;

                    //If next match index is within currentNode
                    if(targetMatchStartIndex < currentNodeMaxIndex){
                        //Bypass incrementing tempIndex and currentNode
                        continue;
                    }
                }
                //Exit loop
                else{
                    break;
                }
            }
            tempIndex = currentNodeMaxIndex;
            currentNode = treeWalker.nextNode();
        }

        //If only retrieving certain occurence of match
        if(occurence!=null && rangeIndices[occurence-1]){
            rangeIndices = [rangeIndices[occurence-1]];
        }

        //Convert rangeIndices into array of ranges
        var ranges = rangeIndices.map((indices, i) => {
            try {
                const range = new Range();
                range.setStart(indices.start[0], indices.start[1]);
                range.setEnd(indices.end[0], indices.end[1]);
                return range;
            } 
            catch(rangeError){
                config.isDebugEnabled && console.log(rangeError);
            }
        });

        // Create a Highlight object for the ranges.
        const searchResultsHighlight = new window.Highlight(...ranges.flat());
        
        //Set priority of highlight (larger numbers have higher priority)
        if(priority!=null){
            searchResultsHighlight.priority=priority;
        }
        
        // Register the Highlight object in the registry.
        CSS.highlights.set(highlightKey!=null ? highlightKey : "search-results", searchResultsHighlight);
    }
    catch(err){
        config.isDebugEnabled && console.log(err);
    }
}